import { useEffect, useState, useRef, forwardRef, useImperativeHandle } from "react";
import { appConfig } from "../../../../config/Config";
import dayjs from "dayjs";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

import { ListChildComponentProps, VariableSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

import { HttpChatApi } from "../../../interface/chat-rest-api";
import { userState } from "../../../interface/MainInterface";
import { CommonUtils } from "../../../Utils/common_utils";
import * as ChatConstant from "./ChatConstant";
import "./Chat.css";

interface propsType {
  broad_seq: string;
  channelArn: string;
  adminArn: string;
  chatUrl: string;
  chat_open: boolean;
  screenMode: string;
  hidden_menu: boolean;
  chatInitCallback: any;
  player_id: string;
  streamEventCallback: any;
  videoPosition: string;
  vod_started_at: string;
  userState: userState;
  isNotFloat: any;
  isFloat: any;
  pcMode: boolean;
  setLiveProducts: any;
  setPinMsg: any;
}

const chatApi = new HttpChatApi();

const ChatVerVod = (props: propsType, ref: any) => {
  const cUtils = new CommonUtils();

  const chatTextSize: string = "14px";

  const chatInnerRef = useRef<HTMLDivElement>();
  const listRef = useRef<any>(null); // Ref for chatting list
  const rowHeights = useRef<any>({}); // Array for set dynamic height foreach message contents

  const [messages, setMessages] = useState<any>([]);
  const [pinMessages, setPinMessages] = useState<any>([]);
  const [totalMessages, setTotalMessages] = useState<any>([]);
  const [needScrollEnd, setNeedScrollEnd] = useState<Boolean>(true);
  const [btnNewMsgBoxStyle, setBtnNewMsgBoxStyle] = useState({ display: "none" });
  const [visibleStartIndex, setVisibleStartIndex] = useState(0);
  const [visibility, setVisibility] = useState("visible");

  const [chatHeight, setChatHeight] = useState("30vh");
  const [chatFontColor, setChatFontColor] = useState("rgb(255, 255, 255)");
  const [adminFontColor, setAdminFontColor] = useState("#F2FF5A");
  const [myFontColor, setMyFontColor] = useState("#80C9FF");
  const [otherFontColor, setOtherFontColor] = useState("#00000066");

  useEffect(() => {
    return () => {
      // 메모리 누수를 방지하기 위해서 컴포넌트 언마운트시 State를 초기화 한다.
      setMessages([]);
      setPinMessages([]);
      setTotalMessages([]);
      setNeedScrollEnd(true);
      setBtnNewMsgBoxStyle({ display: "none" });
      setVisibleStartIndex(0);
      setVisibility("visible");
      setChatHeight("30vh");
      setChatFontColor("rgb(255, 255, 255");
      setAdminFontColor("#F2FF5A");
      setMyFontColor("#80C9FF");
      setOtherFontColor("#00000066");
    };
  }, []);

  useEffect(() => {
    if (props.hidden_menu && !props.chat_open) {
      setVisibility((visibility) => "hidden");
      setBtnNewMsgBoxStyle({ display: "none" });
    } else {
      setVisibility((visibility) => "visible");
    }
  }, [props.hidden_menu, props.chat_open]);

  useEffect(() => {
    if (props.channelArn !== "") {
      getListChannelMessages(props.channelArn);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.channelArn]);

  // 최초 채널 입장시 기존 차임 메시지 조회(현재 최대 50건)
  const getListChannelMessages = async (channel_arn: string) => {
    const param: any = {
      channel_arn: channel_arn,
      broad_seq: props.broad_seq,
    };
    await chatApi.list_chat_history(param).then((result: any) => {
      if (result.code === "200") {
        // VOD때는 제외
        // props.setLiveProducts(result.response.live_products);
        setTotalMessages(result.response.chat_history.Messages);
        setPinMessages(result.response.pin_messages);
        props.chatInitCallback(true);
      }
    });
  };

  useEffect(() => {
    // useEffect의 특성상 1초에 한번씩만 업데이트 됨. 나이스~
    let newMessages: any = [];
    let newManageMessages: any = [];
    for (let msg of totalMessages) {
      if (msg.CreatedTimestamp < props.vod_started_at) continue;
      if (msg.CreatedTimestamp > props.videoPosition) break;
      if (msg.Persistence === ChatConstant.Persistence.NON_PERSISTENT && JSON.parse(msg.Content).prot === "view") continue;
      if (msg.Persistence === ChatConstant.Persistence.NON_PERSISTENT) {
        const tmp_ts = dayjs(props.videoPosition).add(-1, "s").format("YYYYMMDDHHmmss");
        if (msg.CreatedTimestamp < tmp_ts) continue;
        newManageMessages = [...newManageMessages, msg];
        continue;
      }
      if (msg.Type === "PRIVATE" && msg.Receiver !== props.userState.id) continue;
      newMessages = [...newMessages, msg];
    }
    setMessages(newMessages);

    let newPinMessages: any = [];
    for (const pin of pinMessages) {
      if (pin.sk < props.vod_started_at) continue;
      if (pin.sk > props.videoPosition) break;
      newPinMessages = [...newPinMessages, pin];
    }
    if (newPinMessages.length > 0) {
      props.setPinMsg(newPinMessages[newPinMessages.length - 1].message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.videoPosition]);

  // 채팅창 ListItem의 높이를 동적 처리하기 위한 기능
  function getRowHeight(index: number) {
    return rowHeights.current[index] + 8 || 36;
  }

  // 각 row별 높이를 저장하기 위한 기능
  function setRowHeight(index: any, size: any) {
    listRef.current?.resetAfterIndex(0);
    rowHeights.current = { ...rowHeights.current, [index]: size };
  }

  const AutoLink = (prop: any) => {
    const delimiter = /(https?:\/\/[^\s]+)/g;
    return (
      <>
        {prop.text.split(delimiter).map((word: any, index: number) => {
          const match = word.match(delimiter);
          if (match) {
            const url = match[0];
            return (
              <a
                key={`a-t-k-${index}`}
                style={{ textDecoration: "underline", color: "#FF376D" }}
                target="_blank"
                href={url.startsWith("http") ? url : `http://${url}`}
                rel="noreferrer"
              >
                {url}
              </a>
            );
          }
          return word;
        })}
      </>
    );
  };

  // 채팅 메시지별 Row 그리는 기능(동적 높이 구현을 위한 기능 포함)
  function RenderRow(listProps: ListChildComponentProps) {
    const { index, style } = listProps;
    const newStyle = {
      left: "0px",
      height: style.height,
      width: "100%",
    };

    const rowRef = useRef<any>({});

    useEffect(() => {
      if (rowRef.current) {
        setRowHeight(index, rowRef.current?.clientHeight);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowRef]);

    return (
      <ListItem style={visibleStartIndex > 0 ? style : newStyle} key={index}>
        <ListItemText
          primary={
            <Typography ref={rowRef} component="div" className="chat-list-body">
              <Box
                sx={
                  messages[index].Sender.Arn === props.adminArn && messages[index].Type === "PRIVATE" && messages[index].Receiver === props.userState.id
                    ? {
                        fontSize: chatTextSize,
                        fontWeight: "500",
                        color: "Snow",
                        display: "inline-flex",
                        flexDirection: "row",
                        borderRadius: 2,
                        backgroundColor: "#ffb20030",
                        pl: 1,
                        pr: 1,
                        pt: 1,
                        pb: 1,
                      }
                    : messages[index].Sender.Arn === props.adminArn
                    ? {
                        fontSize: chatTextSize,
                        fontWeight: "500", //"bold",
                        color: "Snow",
                        display: "inline-flex",
                        flexDirection: "row",
                        borderRadius: 2,
                        backgroundColor: "#00000030", //"transparent",
                        // border: "solid 1px",
                        // borderColor: "snow",
                        pl: 1,
                        pr: 1,
                        pt: 1,
                        pb: 1,
                      }
                    : {
                        fontSize: chatTextSize,
                        fontWeight: "500", //"bold",
                        color: "Snow",
                        display: "inline-flex",
                        flexDirection: "row",
                        borderRadius: 2,
                        // pl: 1,
                        // pr: 1,
                      }
                }
              >
                <div>
                  <span
                    style={
                      messages[index].Sender.Arn === props.adminArn
                        ? {
                            color: adminFontColor, // 어드민, 노랑색
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            marginRight: "5px",
                          }
                        : messages[index].Sender.Arn === props.userState.userArn
                        ? {
                            color: myFontColor, // 본인, 파랑색
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            marginRight: "5px",
                          }
                        : {
                            color: otherFontColor, // 일반 회원(어드민 제외), 회색
                            whiteSpace: "nowrap",
                            fontWeight: "bold",
                            marginRight: "5px",
                          }
                    }
                  >
                    {messages[index].Sender.Arn === props.adminArn
                      ? messages[index].Sender.Name
                      : cUtils.maskingChar(messages[index].Sender.Name)}
                  </span>
                  {messages[index].Content.split(appConfig.quote_separator).map((line: string, idx: number) => {
                    const repleLength = messages[index].Content.split(appConfig.quote_separator).length;
                    let styleCss: any = {
                      color: chatFontColor,
                      wordBreak: "break-all",
                      whiteSpace: "pre-line",
                    };
                    // if (messages[index].Sender.Arn === props.adminArn && props.pcMode) styleCss.color = adminFontColor;
                    // if (messages[index].Sender.Arn !== props.adminArn && props.pcMode) styleCss.fontWeight = "normal";
                    // if (idx !== repleLength - 1) styleCss.color = "#ebeaea";
                    // if (idx !== repleLength - 1 && props.pcMode) styleCss.color = "#00000070"; // pc mode 3분할인 경우, 채팅 바탕색이 하얀색이므로 글자색은 어둡게
                    if (idx !== repleLength - 1) styleCss.fontWeight = "normal";
                    if (idx === 0 && messages[index].Sender.Arn === props.adminArn) {
                      return (
                        <span key={index} style={styleCss}>
                          <AutoLink text={line} />
                        </span>
                      );
                    } else if (idx === 0) {
                      return (
                        <span key={index} style={styleCss}>
                          {line}
                        </span>
                      );
                    } else {
                      // styleCss.color = "#59f4f4";
                      // if (messages[index].Sender.Arn === props.adminArn && props.pcMode) styleCss.color = adminFontColor;
                      return (
                        <span key={index + "-" + idx} style={styleCss}>
                          <br />
                          {appConfig.quote_separator + " "}
                          <AutoLink text={line} />
                        </span>
                      );
                    }
                  })}
                </div>
              </Box>
            </Typography>
          }
        />
      </ListItem>
    );
  }

  // 스크롤에 따라서 최신 메시지, 스크롤 자동 하단 등 처리를 위한 이벤트
  const evtItemRendered = (e: any) => {
    if (chatInnerRef.current) chatInnerRef.current.style.marginTop = "auto";
    setVisibleStartIndex((visibleStartIndex) => e?.visibleStartIndex);

    if (e?.visibleStopIndex > 0 && messages.length > 0) {
      if (e.visibleStopIndex >= messages.length - 1) {
        setNeedScrollEnd(true);
        setBtnNewMsgBoxStyle({ display: "none" });
      } else {
        setNeedScrollEnd(false);
      }
    }
  };

  // 채팅창 스크롤 제일 아래로 이벤트 처리
  useEffect(() => {
    if (messages.length > 0) {
      if (needScrollEnd) {
        setBtnNewMsgBoxStyle({ display: "none" });
        scrollToBottom();
      } else {
        if (!props.hidden_menu) setBtnNewMsgBoxStyle({ display: "inline" });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, needScrollEnd]);

  // 채팅창 내용 업데이트시 스크롤을 제일 아래로
  const scrollToBottom = () => {
    if (messages.length > 0) {
      listRef?.current?.scrollToItem(messages.length, "end");
    }
  };

  useEffect(() => {
    // if (props.pcMode) {
    //   setChatHeight("100%");
    //   setChatFontColor("#1d1c1b");
    //   setAdminFontColor("#6C66CF");
    //   setMyFontColor("#80C9FF");
    //   setOtherFontColor("#00000080");
    // } else {
    //   setChatHeight("30vh");
    //   setChatFontColor("rgb(255, 255, 255)");
    //   setAdminFontColor("#F2FF5A");
    //   setMyFontColor("#80C9FF");
    //   setOtherFontColor("#ffffff90");
    // }
    setChatHeight("30vh");
    setChatFontColor("rgb(255, 255, 255)");
    setAdminFontColor("#F2FF5A");
    setMyFontColor("#80C9FF");
    setOtherFontColor("#ffffff90");
  }, [props.pcMode]);

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    scrollToBottom,
  }));

  return (
    <>
      <Box
        id="chat-root"
        component="div"
        sx={
          /* 메인화면에서 비디오영역 클릭시 메뉴 감추기 */
          {
            // width: "90%",
            height: chatHeight,
            visibility: visibility,
          }
        }
        className="chat-root"
      >
        <>
          {/* 체팅창 영역 */}
          <Box
            id="chat-box"
            component="div"
            sx={{
              width: "100%",
              height: "100%",
              position: "relative",
            }}
            className={visibleStartIndex > 0 ? "gradient-box" : ""}
          >
            <Box sx={{ height: "100%", width: "100%" }}>
              <AutoSizer style={{ height: "100%", width: "100%" }}>
                {({ height, width }) => (
                  <VariableSizeList
                    height={height}
                    width={width}
                    itemSize={getRowHeight}
                    itemCount={messages.length}
                    overscanCount={5}
                    className="chat-list"
                    innerRef={chatInnerRef}
                    ref={listRef}
                    onItemsRendered={evtItemRendered}
                  >
                    {RenderRow}
                  </VariableSizeList>
                )}
              </AutoSizer>
            </Box>
            {/* 체팅창 스크롤 위로갈때 스크롤 아래로 이동하는 버튼 */}
            <Box className="btn-new-chat" sx={btnNewMsgBoxStyle}>
              <Button
                sx={{ backgroundColor: "#ff376d", "&:hover": { backgroundColor: "#ff376d" } }}
                variant="contained"
                size="small"
                onClick={scrollToBottom}
                endIcon={<ArrowCircleDownIcon />}
              >
                <span>최신 채팅으로 이동</span>
              </Button>
            </Box>
          </Box>
        </>
      </Box>
    </>
  );
};

export default forwardRef(ChatVerVod);
